import { useContext } from 'react';

import { InstanceContext } from 'src/domain/instances/InstancesProvider';

export const useInstances = () => {
  const instancesState = useContext(InstanceContext);
  return instancesState;
};
